export default __webpack_public_path__ + "static/media/GW.608fd370.svg";